import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-content-title',
  templateUrl: './content-title.component.html',
  styleUrls: ['./content-title.component.scss'],
  imports: [CommonModule],
  standalone: true
})
export class ContentTitleComponent {
  @Input() content: string;
  @Input() protected contentType: string;
}
